module.exports = __webpack_public_path__ + "static/media/YF87_2.38014883.jpg";